import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TextBoxModule } from '@progress/kendo-angular-inputs';
import { SVGIcon, searchIcon } from '@progress/kendo-svg-icons';
import { KENDO_SVGICON } from '@progress/kendo-angular-icons';

@Component({
  selector: 'app-ai-search-bar',
  standalone: true,
  imports: [CommonModule, FormsModule, TextBoxModule, KENDO_SVGICON],
  templateUrl: './ai-search-bar.component.html',
  styleUrl: './ai-search-bar.component.scss'
})
export class AiSearchBarComponent {
  @Input() placeholder: string = 'Search documents...';
  @Input() set initialValue(value: string) {
    this.searchTerm.set(value);
  }
  @Output() search = new EventEmitter<string>();

  searchTerm = signal<string>('');
  searchIcon: SVGIcon = searchIcon;

  onSearchTermChange(value: string): void {
    this.searchTerm.set(value);
  }

  onSearch(): void {
    const term = this.searchTerm().trim();
    this.search.emit(term);
  }

  onKeyUp(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.onSearch();
    }
  }

  onClear(): void {
    this.searchTerm.set('');
    this.search.emit('');
  }
}
